module.exports = __webpack_public_path__ + "static/media/05_coach_details.af1bec9e.png";